import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { caApi } from "../../../backend_urls/caApi";
import { CAURL } from "../../../routes/ca_routes/CAURL";
import ModalPopup from "../../../components/popups/DefaultPopUp";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import ActionButtons from "../../../utils/ActionButtons";
import CreateInvoice from "./models/invoice_model/CreateInvoice";
import "../../../css/pages/ca_pages/CAAllInvoicesPage.css";

const CAAllInvoicesPage = () => {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [ invoiceApprovalPopup, setInvoiceApprovalPopup ] = useState(false);
    const [ showDeletePopup, setShowDeletePopup ] = useState(false);
    const [ selectedRecord, setSelectedRecord ] = useState(null);
    const [ createPopup, setCreatePopup ] = useState(false);

    /* Fetch invoices */
    const fetchData = async () => {
        try {
            setLoading(true);

            const response = await caApi.listClientInvoices();
            setData(response?.data || response || []);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally { setLoading(false); }
    };
    useEffect(() => { fetchData(); }, []);

    /* Delete */

    const handleDelete = (invoiceId) => {
        if (!invoiceId) { return; }
        setSelectedRecord(invoiceId);
        setShowDeletePopup(true);
    };

    const confirmDelete = async () => {
        if (!selectedRecord) { return; }

        try {
            setLoading(true);

            await caApi.destroyClientInvoice(selectedRecord);
            setShowDeletePopup(false);
            setSelectedRecord(null);
            await fetchData();
        } catch (error) {
            console.error("Error deleting invoice:", error);
        } finally { setLoading(false); }
    };

    /* Edit */
    const handleEdit = (invoiceId) => {
        if (!invoiceId) { return; }
        navigate( CAURL.ca_clients_invoice_edit(invoiceId) );
    };

    /* Approve */
    const handleApprove = (invoiceId) => {
        if (!invoiceId) { return; }
        setSelectedRecord(invoiceId);
        setInvoiceApprovalPopup(true);
    };

    const confirmApprove = async () => {
        if (!selectedRecord) { return; }

        try {
            setLoading(true);
            await caApi.approveClientInvoice(selectedRecord);
            setInvoiceApprovalPopup(false);
            setSelectedRecord(null);

            await fetchData();
        } catch (error) {
            console.error("Error approving invoice:", error);
        } finally { setLoading(false); }
    };

    /*
    |--------------------------------------------------------------------------
    | Create Invoice Success
    |--------------------------------------------------------------------------
    |
    | This is the important parent-child connection.
    |
    */
    const handleCreateInvoiceSuccess = async () => {
        console.log("CAAllInvoicesPage -> Invoice created successfully");

        /* Re-fetch the invoice list. */
        await fetchData();

        /*
        |--------------------------------------------------------------------------
        | Don't need setCreatePopup(false) here.
        |
        | CreateInvoice will call onClose after this function
        | completes.
        |--------------------------------------------------------------------------
        */
    };

    return (
        <>
            {loading ? <LoadingSpinner /> : (
                <div className="ca-invoices-page">
                    {/* HEADER */}
                    <div className="ca-invoices-header">
                        <div>
                            <h1>All Invoices</h1>
                            <p>Manage all client invoices</p>
                        </div>

                        <button
                            className="create-invoice-btn"
                            onClick={() => setCreatePopup(true) }
                        >
                            Create Invoice
                        </button>
                    </div>

                    {/* TABLE */}
                    <div className="invoice-table-wrapper">
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>Invoice</th>
                                    <th>Business</th>
                                    <th>Date</th>
                                    <th>Bill Value</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length > 0 ? (
                                    data.map(
                                        (invoice) => (
                                            <tr
                                                key={ invoice.id }
                                            >
                                                {/* Invoice */}
                                                <td>
                                                    <div className="invoice-info">
                                                        <p className="invoice-number">
                                                            {
                                                                invoice.invoice_number ||
                                                                "N/A"
                                                            }
                                                        </p>

                                                        <span className="invoice-id">
                                                            ID:{" "}
                                                            { invoice.id }
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Business */}
                                                <td>
                                                    <div className="client-info">
                                                        <p className="client-name">
                                                            { invoice.business_name }
                                                        </p>

                                                        <span className="client-email">
                                                            ( { invoice.business_gstin || "-" } )
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Date */}
                                                <td>
                                                    {
                                                        invoice.invoice_date
                                                            ? new Date(
                                                                  invoice.invoice_date
                                                              ).toLocaleDateString()
                                                            : "-"
                                                    }
                                                </td>

                                                {/* Total */}

                                                <td className="invoice-total">
                                                    ₹{ invoice.grand_total || "0.00" }
                                                </td>

                                                {/* Status */}
                                                <td>
                                                    <span
                                                        className={`status-badge ${invoice.review_status}`}
                                                    >
                                                        { invoice.review_status }
                                                    </span>
                                                </td>

                                                {/* Actions */}
                                                <td>
                                                    <div className="table-actions">
                                                        <ActionButtons
                                                            actions={[
                                                                {
                                                                    buttonType: "editIcon",
                                                                    iconSize: 18,
                                                                    onClick: () => handleEdit(invoice.id),
                                                                },

                                                                {
                                                                    buttonType:
                                                                        "deleteIcon",

                                                                    iconSize: 18,

                                                                    onClick:
                                                                        () =>
                                                                            handleDelete(
                                                                                invoice.id
                                                                            ),
                                                                },

                                                                {
                                                                    buttonType:
                                                                        "viewSecondary",

                                                                    customName:
                                                                        "Approve",

                                                                    onClick:
                                                                        () =>
                                                                            handleApprove(
                                                                                invoice.id
                                                                            ),
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    )
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="6"
                                            className="no-data"
                                        >
                                            No invoices
                                            found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* ==================================================
                DELETE POPUP
            ================================================== */}

            <ModalPopup
                isOpen={
                    showDeletePopup
                }
                onClose={() => {
                    setShowDeletePopup(false);
                    setSelectedRecord(null);
                }}
                title="Delete Record"
                subtext="Are you sure you want to delete this record?"
                actionText="Delete"
                onAction={
                    confirmDelete
                }
            />

            {/* ==================================================
                APPROVAL POPUP
            ================================================== */}

            <ModalPopup
                isOpen={
                    invoiceApprovalPopup
                }
                onClose={() => {
                    setInvoiceApprovalPopup(
                        false
                    );

                    setSelectedRecord(
                        null
                    );
                }}
                title="Invoice Approval Confirmation"
                subtext="Are you sure you want to Approve this Invoice?"
                actionText="Approve"
                onAction={
                    confirmApprove
                }
            />

            {/* ==================================================
                CREATE INVOICE
            ================================================== */}

            {createPopup && (
                <CreateInvoice
                    isOpen={createPopup}

                    onClose={() => {
                        setCreatePopup(false);
                    }}

                    onSuccess={
                        handleCreateInvoiceSuccess
                    }
                />
            )}
        </>
    );
};

export default CAAllInvoicesPage;
